// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1750":"css/app.6796","9295":"css/admin-app.6796"}[chunkId] + ".css";
};